import {API_URL, CMS_URL, THEME_COLOR} from "../constant"
import React, {useEffect, useState} from 'react';
import { useLocalStorage } from "../useLocalStorage";
import {each, jQuery as $} from "jquery";
import toast, { Toaster } from 'react-hot-toast';

import banner from "../images/flashsalesonline/banner-min.png"
import kirana from "../images/flashsalesonline/kirana.png"
import fresca from "../images/flashsalesonline/fresca.png"
import ovale from "../images/flashsalesonline/ovale.png"
import vaso from "../images/flashsalesonline/vaso.png"

import "./FlashSalesOnline.css";
import { amber } from "@mui/material/colors";

import CENA from "../images/bank/Bank_Central_Asia.png";
import BMRI from "../images/bank/Bank_Mandiri.png";
import BBBA from "../images/bank/Bank_Permata.png";
import BNIN from "../images/bank/BNI.png";
import BRIN from "../images/bank/BRI.png";
import BNIA from "../images/bank/CIMB.png";
import BDIN from "../images/bank/Danamon.png";
import HNBN from "../images/bank/KEB-Hana.png";
import IBBK from "../images/bank/Maybank.png";

const FlashSalesOnline = () => {
    
    const [token, setToken] = useLocalStorage("token", "");
    const [discount, setDiscount] = useState(0);
    const [redeem, setRedeem] = useState(0);
    const [total, setTotal] = useState(0);
    const [grandtotal, setGrandTotal] = useState(0);
    const [promos, setPromos] = useState([]);
    const [qtys, setQtys] = useState([]);
    const [bankid, setBankid] = useState("BMRI");
    const [banknames, setBanknames] = useState({
        "BMRI":"Bank Mandiri",
        "IBBK":"Bank International Indonesia Maybank",
        "BBBA":"Bank Permata",
        "CENA":"Bank Central Asia",
        "BNIN":"Bank Negara Indonesia 46",
        "HNBN":"Bank KEB Hana Indonesia",
        "BRIN":"Bank Rakyat Indonesia",
        "BNIA":"Bank PT. BANK CIMB NIAGA, TBK.",
        "BDIN": "Bank PT. BANK DANAMON INDONESIA, TBK"
    });
    const [valid, setValid] = useState(true)
    const [member, setMember] = useState({
        ismember : "1",
        ceoid: "",
        memberid: "",
        name: "1",
        phone: "",
        province: "",
        city: ""
    })

    useEffect(async ()=>{
        await initPromo();
        await initCEO();
        await initProvince();
        await initMemberData();
        // changeProvince();
        // changeCity();
        // changeIsMember();
        // changeForgotMember();
        // blurMemberID();
    },[])

    function getPromo(){
        var myHeaders = new Headers();
        myHeaders.append("x-access-token", token);

        var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
        };

        return fetch(`${API_URL}api/flashpromo`, requestOptions)
        .then(response => response.json())
        .catch(error => {});
    }
    async function initPromo(){
        let res = await getPromo();
        let tstate = res.data;
        setPromos(tstate);
    }

    function getCEO(){
        
        var myHeaders = new Headers();
        myHeaders.append("x-access-token", token);

        var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
        };

        return fetch(`${API_URL}api/ceo`, requestOptions)
        .then(response => response.json())
        .catch(error => {});
    }

    async function initCEO(){
        let res = await getCEO();
        var select = document.getElementById("CEOID");
        select.innerHTML= '';
        var optdefault = document.createElement("option");
        await res.data.map((value, index, arr)=>{
            var option = document.createElement("option");
            option.value = value.ID;
            option.text = value.Name;
            if(value.ID == member.ceoid)
                option.selected = true;
            select.add(option)
        })
        select.onchange = changeCEO;
    }


    function getProvince(){
        var myHeaders = new Headers();
        myHeaders.append("x-access-token", token);

        var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
        };

        return fetch(`${API_URL}api/province/47`, requestOptions)
        .then(response => response.json())
        .catch(error => {});
    }
    async function initProvince(){
        let res = await getProvince();
        var select = document.getElementById("Province");
        select.innerHTML = '';
        var optdefault = document.createElement("option");
        optdefault.value = "";
        optdefault.text = "--Pilih Provinsi--";
        select.add(optdefault);
        res.data.map((value, index, arr)=>{
            var option = document.createElement("option");
            option.value = value.value;
            option.text = value.label;
            if(value.value == member.province)
                option.selected = true;
            select.add(option)
        })
        select.onchange = changeProvince;
    }

    function getCity(){
        var myHeaders = new Headers();
        myHeaders.append("x-access-token", token);

        var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
        };

        return fetch(`${API_URL}api/city/${member.province}`, requestOptions)
        .then(response => response.json())
        .catch(error => {});
    }
    async function initCity(){
        let res = await getCity();
        var select = document.getElementById("City");
        select.innerHTML ='';
        var optdefault = document.createElement("option");
        optdefault.value = "";
        optdefault.text = "--Pilih Kota--";
        select.add(optdefault);
        await res.data.map((value, index, arr)=>{
            var option = document.createElement("option");
            option.value = value.value;
            option.text = value.label;
            if(value.value == member.city)
                option.selected = true;
            select.add(option)
        })
        select.onchange = changeCity;
    }

    function getDistrict(){
        var myHeaders = new Headers();
        myHeaders.append("x-access-token", token);

        var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
        };

        return fetch(`${API_URL}api/district/${member.city}`, requestOptions)
        .then(response => response.json())
        .catch(error => {});
    }
    async function initDistrict(){
        let res = await getDistrict();
        var select = document.getElementById("District");
        select.innerHTML='';
        var optdefault = document.createElement("option");
        optdefault.value = "";
        optdefault.text = "--Pilih Kecamatan--";
        select.add(optdefault);
        await res.data.map((value, index, arr)=>{
            var option = document.createElement("option");
            option.value = value.ID;
            option.text = value.Name;
            select.add(option)
        })
    }

    function getMemberData(){
        var myHeaders = new Headers();
        myHeaders.append("x-access-token", token);

        var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
        };

        return fetch(`${API_URL}api/member`, requestOptions)
        .then(response => response.json())
        .catch(error => {});
    }
    async function initMemberData(){
        let res = await getMemberData();
        res = res.data;
        let tstate = {...member};
        tstate.ismember = "1";
        tstate.memberid= res.Code;
        tstate.name= res.Name;
        tstate.phone= res.MobilePhone;
        tstate.province= res.ProvinceID;
        tstate.city= res.CityID;
        tstate.ceoid= res.CEOID;
        setMember(tstate);
        // $("#Province").val(res.ProvinceID).trigger("change");
        // $("#CEOID").val(res.CEOID).trigger("change");
        // var event = new Event("change");
        // document.getElementById("Province").value= res.ProvinceID;
        // document.getElementById("Province").dispatchEvent(event);
        // event = new Event("change");
        // document.getElementById("CEOID").value= res.CEOID;
        // document.getElementById("CEOID").dispatchEvent(event);
    }

    function intVal(i) {
        return typeof i === 'string' ?
            i.replace(/[\$,]/g, '') * 1 :
            typeof i === 'number' ?
            i : 0;
    };

    function blurMemberID(){
        initMemberData();
    }

    function changeQty(e){
        let tstate = [...promos];
        let index = (e.target.id).replace("qty-", "");
        let value = intVal(e.target.value);
        if(value > tstate[index].MaxOrder){
            value = tstate[index].MaxOrder
        }
        if(value> tstate[index].Outstanding)
            value = tstate[index].Outstanding;
        if(value < 0){
            value = 0;
        }
        tstate[index].OrderQty = value;
        setPromos(tstate);
        recalculate();

    }

    function increaseQty(index){
        let tstate = [...promos];
        tstate[index].OrderQty++;
        if(tstate[index].OrderQty > tstate[index].MaxOrder)
            tstate[index].OrderQty = tstate[index].MaxOrder;
        if(tstate[index].OrderQty > tstate[index].Outstanding)
            tstate[index].OrderQty = tstate[index].Outstanding;
        setPromos(tstate);
        recalculate();
    }

    function decreaseQty(index){
        let tstate = [...promos];
        tstate[index].OrderQty--;
        if(tstate[index].OrderQty < 0)
            tstate[index].OrderQty = 0;
        setPromos(tstate);
        recalculate();
    }

    function changeForgotMember(){
        // $("#ForgotMember").change(()=>{
        //     if($("#ForgotMember").prop("checked")){
        //         $("#IDMember").attr("disabled", true);
        //         $("#Name").attr("disabled", false);
        //         // $("#CityDiv").show();
        //     }else{
        //         $("#IDMember").attr("disabled", false);
        //         $("#Name").attr("disabled", true);
        //         $("#CityDiv").hide();
        //     }
        //     let tstate = {...this.state};
        //     tstate.member.memberid = "";
        //     tstate.member.name = "";
        //     tstate.member.phone = "";
        //     this.setState(tstate);

        // })
    }

    function changeIsMember(){
        if($("input[type=radio][name=isMember]:checked").val() == 1){
            $("#IDMemberDiv").show();
            $("#CEOIDDiv").show();
            $("#IDMember").attr("disabled", false);
            $("#Name").attr("disabled", true);
            let tstate = {...member};
            tstate.ismember = "1";
            tstate.memberid = "";
            tstate.name = "";
            tstate.phone = "";
            tstate.province = "";
            tstate.city = "";
            tstate.ceoid = "";
            setMember(tstate)
        }else{
            $("#IDMemberDiv").hide();
            $("#CEOIDDiv").hide();
            $("#ForgotMember").prop("checked", false)
            $("#IDMember").attr("disabled", false);
            $("#Name").attr("disabled", false);
            let tstate = {...member};
            tstate.ismember = "0";
            tstate.memberid = "";
            tstate.name = "";
            tstate.phone = "";
            tstate.province = "";
            tstate.city = "";
            tstate.ceoid = "";
            setMember(tstate)
        }
    }

    function changeMemberID(e){
        let tstate = {...member};
        tstate.memberid = e.target.value;
        setMember(tstate);
    }

    function changeMemberName(e){
        let tstate = {...member};
        tstate.name = e.target.value;
        setMember(tstate);
    }

    function changeMemberPhone(e){
        let tstate = {...member};
        tstate.phone = e.target.value;
        setMember(tstate);
    }


    function changeProvince(e){
        let tstate = {...member};
        tstate.province = e.target.value;
        setMember(tstate);
        initCity();
    }

    function changeCity(e){
        let tstate = {...member};
        tstate.city = e.target.value;
        setMember(tstate);
        initDistrict();
    }

    function changeCEO(e){
        let tstate = {...member};
        tstate.ceoid = e.target.value;
        setMember(tstate);
    }

    function numberWithCommas(x) {
        x= parseInt	(x);
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    function selectBank(newbankid){
        document.getElementById(bankid).classList.remove("bank-selected");
        setBankid(newbankid)
        document.getElementById(newbankid).classList.add("bank-selected");
    }

    function checkFields(){
        var tvalid = true;
        var fields= ["Name","HP"];
        fields.map( async (field, index, array)=>{
            if(document.getElementById(field).value==""){
                tvalid = false
                document.getElementById(field).classList.add("form-error");
                document.getElementById(field+"-required").innerHTML = "this field is required";
            }else{
                document.getElementById(field).classList.remove("form-error");
                document.getElementById(field+"-required").innerHTML = "";
            }
        })
        let allempty = true;
        for (let index = 0; index < promos.length; index++) {
            const element = promos[index].OrderQty;
            allempty = allempty && element == 0;
        }
        tvalid = tvalid && !allempty;
        setValid(tvalid);
        if(!tvalid){
            toast.error("Fill out all field");
        }
        return tvalid;
    }

    function submitAction(){
        var myHeaders = new Headers();
        myHeaders.append("x-access-token", token);
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

        var urlencoded = new URLSearchParams();
        urlencoded.append('IsMember', member.ismember)
        urlencoded.append('MemberID', member.memberid)
        urlencoded.append('MemberName', member.name)
        urlencoded.append('MemberAddress','')
        urlencoded.append('MemberProvince',member.province)
        urlencoded.append('MemberCity',member.city)
        urlencoded.append('MemberDistrict','')
        urlencoded.append('MemberZipCode','')
        urlencoded.append('MemberMobilePhone',member.phone)
        urlencoded.append('MemberEmail','')
        urlencoded.append('SponsorUsername ', '')
        urlencoded.append('Discount', discount)
        urlencoded.append('Redeem', redeem)
        urlencoded.append('Total', total)
        urlencoded.append('GrandTotal', grandtotal)
        urlencoded.append('bankcd', bankid)
        urlencoded.append('bankname', banknames[bankid])
        urlencoded.append('ShippingFee', 0)
        urlencoded.append('Promos', JSON.stringify(promos))


        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: urlencoded,
            redirect: 'follow'
        };

        return fetch(`${API_URL}api/flashsalesonline/checkout`, requestOptions)
        .then(response => response.json())
        .catch(error => console.log('error', error))
    }
    async function submitForm(){
        document.getElementById("daftar").innerHTML = `<span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> <span className="sr-only">Loading...</span>`
        document.getElementById("daftar").disabled = true
        if(checkFields()){
            let res = await submitAction();
            if(res.status == 200){
                window.history.replaceState(null, null, `/paymentinfo/${res.data}`);
                toast.success("sukses")
                window.location.reload();
            }
        }else{
            document.getElementById("daftar").innerHTML = `Daftar Sekarang`
            document.getElementById("daftar").disabled = false;
        }
        document.getElementById("daftar").disabled = false;
    }

    function recalculate(){
        let ttotal = 0;
        let tdiscount = 0;
        let tgrandtotal = 0;
        let tredeem = 0;
        promos.map((value,index)=>{
            if(promos[index].OrderQty > 0){
                ttotal += value.CatalogPrice * promos[index].OrderQty;
                tredeem += value.Redeem * promos[index].OrderQty;
            }
        })
        
        setTotal(ttotal);
        setRedeem(tredeem)
        tdiscount = ((member.ismember == "1") ? 30 : 0) * ttotal /100;
        tgrandtotal = ttotal - tdiscount + tredeem;
        setDiscount(tdiscount)
        setGrandTotal(tgrandtotal);

    }

    return (
        <React.StrictMode>
            <Toaster
                position="bottom-center"
            />
            <div className="bg-galaxy">
                <div className="banner">
                    <img src={banner} alt="" />
                </div>
                <div className="container-ecommerce">
                    <h4>Data Diri</h4>
                    <div className="form-group" style={{display:"none"}}>
                        <label >Apakah Member?</label> &nbsp;&nbsp;
                        <div></div>
                        <div className="form-check form-check-inline">
                            <input className="form-check-input" type="radio" name="isMember" id="NonMember" value="0" checked={member.ismember == "0"} onChange={changeIsMember}/>
                            <label className="form-check-label" htmlFor="NonMember">Non Member</label>
                        </div>
                        <div className="form-check form-check-inline">
                            <input className="form-check-input" type="radio" name="isMember" id="Member" value="1" checked={member.ismember == "1"} onChange={changeIsMember} />
                            <label className="form-check-label" htmlFor="Member">Member</label>
                        </div>
                    </div>
                    <div className="form-group" id="IDMemberDiv">
                        <label >ID Member <span className="asterik">*</span><span className="asterik" id="IDMember-required"></span></label>&nbsp;&nbsp;
                        <div className="form-check form-check-inline" style={{display:"none"}}>
                            <input className="form-check-input" type="checkbox" name="ForgotMember" id="ForgotMember" value="1" />
                            <label className="form-check-label" htmlFor="ForgotMember">Lupa ID Member</label>
                        </div>
                        <input type="text" readOnly="readonly" name="IDMember" id="IDMember" className="form-control" placeholder="" value={member.memberid} onChange={changeMemberID} onBlur={blurMemberID}/>
                    </div>
                    <div className="form-group">
                        <label >Nama Lengkap <span className="asterik">*</span><span className="asterik" id="Name-required"></span></label>
                        <input type="text" readOnly="readonly" name="Name" id="Name" className="form-control" value={member.name} onChange={changeMemberName}/>
                    </div>
                    <div className="form-group">
                        <label >No Handphone <span className="asterik">*</span><span className="asterik" id="HP-required"></span></label>
                        <input type="text" name="HP" id="HP" className="form-control" placeholder="" value={member.phone} onChange={changeMemberPhone}/>
                    </div>
                    <div className="form-group" id="CityDiv" style={{display:"none"}}>
                        <label >Kota <span className="asterik">*</span><span className="asterik" id="CityText-required"></span></label>
                        <input type="text" name="CityText" id="CityText" className="form-control" placeholder=""/>
                    </div>
                    <div className="form-group" style={{display:"none"}}>
                        <label >Email <span className="asterik">*</span><span className="asterik" id="Email-required"></span></label>
                        <input type="text" name="Email" id="Email" className="form-control" placeholder=""/>
                    </div>
                    <div className="form-group" id="CEOIDDiv" style={{display:"none"}}>
                        <label >CEO <span className="asterik">*</span><span className="asterik" id="CEOID-required"></span></label>
                        <select name="CEOID" id="CEOID" className="form-control select2" onChange={changeCEO} disabled={member.ismember == "1" && member.memberid != ""}></select>
                    </div>
                    <div className="form-group row" style={{display:"none"}}>
                        <div className="col-md-6">
                            <label >Provinsi <span className="asterik">*</span><span className="asterik" id="Province-required"></span></label>
                            <select name="Province" id="Province" className="form-control select2" onChange={changeProvince} disabled={member.ismember == "1" && member.memberid != ""}></select>
                        </div>
                        <div className="col-md-6">
                            <label >Kota <span className="asterik">*</span><span className="asterik" id="City-required"></span></label>
                            <select name="City" id="City" className="form-control select2" onChange={changeCity} disabled={member.ismember == "1" && member.memberid != ""}></select>
                        </div>
                    </div>
                    <div className="form-group row" style={{display:"none"}}>
                        <div className="col-md-6">
                            <label >Kecamatan <span className="asterik">*</span><span className="asterik" id="District-required"></span></label>
                            <select name="District" id="District" className="form-control select2"></select>
                        </div>
                        <div className="col-md-6">
                            <label >Kode Pos <span className="asterik">*</span><span className="asterik" id="PostalCode-required"></span></label>
                            <input type="text" name="PostalCode" id="PostalCode" className="form-control" placeholder=""/>
                        </div>
                    </div>
                    <div className="form-group" style={{display:"none"}}>
                        <label >Alamat Lengkap <span className="asterik">*</span><span className="asterik" id="Address-required"></span></label>
                        <textarea name="Address" id="Address" className="form-control" placeholder=""></textarea>
                    </div>
                    <div>
                        <input type="hidden" name="SponsorUsername" id="SponsorUsername" value="<?= $username?>" />
                    </div>
                </div>
                <div className="container-ecommerce">
                    <h4>Order Detail</h4>
                    <h5>Pilih paket Promo</h5>
                    {
                        promos.map((value, index)=>{
                            let imgurl = `${CMS_URL}/images/no-image-found.jpg`;
                            if(value.Image1Name){
                                imgurl = `${CMS_URL}/images/flashsalesinvoice/${value.Image1Name}`;
                            }
                            return (
                                <div className="row">
                                    <div className="mycard">
                                        <div className="card-image">

                                            <img src={imgurl} alt=""/>
                                        </div>
                                        <div className="card-qty">
                                            <div style={{position: "relative",flexGrow: "1", width:"150px"}}>
                                                <div className="card-qtyinput">
                                                    <div>Isi jumlah paket promo</div>
                                                    <div className="align-center">
                                                        <div className="qty-row">
                                                            <div className="qty-operation" onClick={()=>decreaseQty(index)}>-</div>
                                                            <div className="qty-text"><input type="text" id={`qty-${index}`} value={value.OrderQty} onChange={changeQty} /></div>
                                                            <div className="qty-operation" onClick={()=>increaseQty(index)}>+</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="card-qtyquota">
                                                tersisa {value.Outstanding} set
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )
                        })
                    }
                    <h4>Total Pembelian</h4>
                    <div className="desktop">
                        <div className="row">
                            <div className="col-sm-3 col-md-3 text-center detail-header"> Nama </div>
                            <div className="col-sm-3 col-md-3 text-center detail-header"> Jumlah </div>
                            <div className="col-sm-3 col-md-3 text-center detail-header"> Harga </div>
                            <div className="col-sm-3 col-md-3 text-center detail-header"> Sub Total </div>
                        </div>
                        <hr/>
                        {
                            promos.map((value, index)=>{
                                if(qtys[index] > 0){
                                    return(
                                        <div className="row">
                                            <div className="col-sm-3 col-md-3"> {value.Name} </div>
                                            <div className="col-sm-3 col-md-3 text-center"> {promos[index].OrderQty}</div>
                                            <div className="col-sm-3 col-md-3 text-right"> Rp. {numberWithCommas(value.CatalogPrice)} </div>
                                            <div className="col-sm-3 col-md-3 text-right"> Rp. {numberWithCommas(promos[index].OrderQty * value.CatalogPrice)} </div>
                                        </div>
                                    );
                                }
                            })
                        }
                        <hr/>
                        <div className="row">
                            <div className="col-sm-9 col-md-9 text-right detail-header">Total</div>
                            <div className="col-sm-9 col-md-3 text-right">Rp. {numberWithCommas(total)}</div>
                        </div>
                        <div className="row">
                            <div className="col-sm-9 col-md-9 text-right detail-header">Diskon</div>
                            <div className="col-sm-9 col-md-3 text-right">Rp. {numberWithCommas(discount)}</div>
                        </div>
                        {
                            (redeem > 0 ) ?(
                                <div className="row">
                                    <div className="col-sm-9 col-md-9 text-right detail-header">Redeem</div>
                                    <div className="col-sm-9 col-md-3 text-right">Rp. {numberWithCommas(redeem)}</div>
                                </div>
                            ) :(<div></div>)
                        }
                        <div className="row">
                            <div className="col-sm-9 col-md-9 text-right detail-header">Grand Total</div>
                            <div className="col-sm-9 col-md-3 text-right">Rp. {numberWithCommas(grandtotal)}</div>
                        </div>
                    </div>
                    <div className="mobile">
                        {
                            promos.map((value, index)=>{
                                if(value.OrderQty > 0){
                                    return(
                                        <div className="row">
                                            <div className="col s8 detail-header"> {value.Name} <span className="asterik">@ {value.OrderQty}</span></div>
                                            <div className="col s4 text-right"> Rp. {numberWithCommas(value.OrderQty* value.CatalogPrice)} </div>
                                        </div>
                                    );
                                }
                            })
                        }
                        <div className="row">
                            <div className="col s8 detail-header">Total</div>
                            <div className="col s4 text-right"> Rp. {numberWithCommas(total)}</div>
                        </div>
                        <div className="row">
                            <div className="col s8 detail-header">Discount</div>
                            <div className="col s4 text-right"> Rp. {numberWithCommas(discount)}</div>
                        </div>
                        {
                            (redeem > 0 ) ?(
                                <div className="row">
                                    <div className="col s8 detail-header">Redeem</div>
                                    <div className="col s4 text-right"> Rp. {numberWithCommas(redeem)}</div>
                                </div>
                            ) :(<div></div>)
                        }
                        <div className="row">
                            <div className="col s8 detail-header">Grand Total</div>
                            <div className="col s4 text-right"> Rp. {numberWithCommas(grandtotal)}</div>
                        </div>
                    </div>
                    <hr/>
                    <h4>Pilih Bank (virtual account)</h4>
                    <div className="row">
                        <div className="col-md-3 bank-item bank-selected" id="BMRI" onClick={() => selectBank("BMRI")}><img className="bank-img" src={BMRI} /></div>
                        <div className="col-md-3 bank-item" id="IBBK" onClick={() => selectBank("IBBK")}><img className="bank-img"  src={IBBK} /></div>
                        <div className="col-md-3 bank-item" id="BBBA" onClick={() => selectBank("BBBA")}><img className="bank-img"  src={BBBA} /></div>
                        <div className="col-md-3 bank-item" id="CENA" onClick={() => selectBank("CENA")}><img className="bank-img"  src={CENA} /></div>
                        <div className="col-md-3 bank-item" id="BNIN" onClick={() => selectBank("BNIN")}><img className="bank-img"  src={BNIN} /></div>
                        <div className="col-md-3 bank-item" id="HNBN" onClick={() => selectBank("HNBN")}><img className="bank-img"  src={HNBN} /></div>
                        <div className="col-md-3 bank-item" id="BRIN" onClick={() => selectBank("BRIN")}><img className="bank-img"  src={BRIN} /></div>
                        <div className="col-md-3 bank-item" id="BNIA" onClick={() => selectBank("BNIA")}><img className="bank-img"  src={BNIA} /></div>
                        <div className="col-md-3 bank-item" id="BDIN" onClick={() => selectBank("BDIN")}><img className="bank-img"  src={BDIN} /></div>
                    </div>
                    <div className="row text-center">
                        <button className="btn btn-daftar" id="daftar" onClick={submitForm}>Bayar Sekarang!</button>
                    </div>
                </div>
            </div>
        </React.StrictMode>
    )
}
  
export default FlashSalesOnline;